import { FC } from 'react';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 搜索按钮 */
const SearchButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

SearchButton.defaultProps = {
  icon: ICON_COLLECTION.SEARCH,
  text: '搜索',
};

export default SearchButton;
